import React from 'react'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

const EXCLUDED_ELEMENTS = ['INPUT', 'TEXTAREA']

interface Props {
  onLeft: () => void
  onRight: () => void
}

export const useNavigationArrows = (
  { onLeft, onRight }: Props,
  deps: React.DependencyList = []
) => {
  useUnsafeEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLBodyElement

      if (target.contentEditable === 'true' || EXCLUDED_ELEMENTS.includes(target.tagName)) {
        return
      }

      if (event.code === 'ArrowLeft') {
        onLeft()
      }

      if (event.code === 'ArrowRight') {
        onRight()
      }
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
